
import md5 from 'md5'
import moment from 'moment'
import { linkToProgram } from '@/api/land.js'

Date.prototype.Format = function (fmt) { // author: meizz
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) { if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
  return fmt
}

/**
 * @description 节流
 */
export function throttle (fn, time) {
  let _arguments = arguments
  let canRun = true
  return function () {
    if (!canRun) return
    canRun = false
    setTimeout(() => {
      fn.call(this, _arguments)
      canRun = true
    }, time)
  }
}
export function getCookie (cookieName) {
  let strCookie = document.cookie
  let arrCookie = strCookie.split('; ')
  for (let i = 0; i < arrCookie.length; i++) {
    let arr = arrCookie[i].split('=')
    if (cookieName == arr[0]) {
      return arr[1]
    }
  }
  return ''
}

/**
 * @description 函数防抖
 */
export function debounce (fn, delay) {
  // 记录上一次的延时器
  var timer = null
  var delay = delay || 200
  return function () {
    var args = arguments
    var that = this
    // 清除上一次延时器
    clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}

/**
 * @description 去除空格
 */
function clearSpease (obj) {
  let iconRule2 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
  if (Object.prototype.toString.call(obj) === '[object Array]') {
    if (obj.length > 0) {
      for (let i = 0; i < obj.length; i++) {
        obj[i] = clearSpease(obj[i])
      }
    }
    return obj
  } else if (Object.prototype.toString.call(obj) === '[object Object]') {
    for (const key in obj) {
      if (Object.prototype.toString.call(obj[key]) === '[object Array]' || Object.prototype.toString.call(obj[key]) === '[object Object]') {
        obj[key] = clearSpease(obj[key])
      } else if (typeof obj[key] === 'string') {
        if (obj[key].indexOf('.com') == -1) {
          obj[key] = obj[key].replace(iconRule2, '')
        }
        obj[key] = obj[key].trim()
      } else {
        obj[key]
      }
    }
    return obj
  } else if (typeof obj === 'string') {
    if (obj.indexOf('.com') == -1) {
      obj = obj.replace(iconRule2, '')
    }
    obj = obj.trim()
    return obj
  } else {
    return obj
  }
}

/**
 * @description 加密
 */
export function addNewColor (obj) {
  let ordered
  // if(obj.params){
  //   ordered = clearSpease(obj.params)
  //   obj.params = ordered
  // }else{
  ordered = clearSpease(obj.data)
  // obj = ordered
  // }
  if ((obj.method) == 'post') {
    let pwd
    if ((typeof (ordered) === 'object' && (Object.prototype.toString.call(ordered).toLowerCase() == '[object object]') && !ordered.length) || (Object.prototype.toString.call(ordered) === '[object Array]')) {
      pwd = JSON.stringify(ordered)
    } else {
      pwd = ordered
    }
    let dataKey = md5(pwd + sysTomName)
    let finalStr = md5(dataKey + sysTomName)
    obj.headers['See-Fetch-Secert'] = finalStr
    console.log(finalStr)
    return obj
  } else {
    return obj
  }
}

/**
 * 是否移动端
 */
export function isMobile () {
  const uA = navigator.userAgent.toLowerCase()
  const ipad = uA.match(/ipad/i) == 'ipad'
  const iphone = uA.match(/iphone os/i) == 'iphone os'
  const midp = uA.match(/midp/i) == 'midp'
  const uc7 = uA.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4'
  const uc = uA.match(/ucweb/i) == 'ucweb'
  const android = uA.match(/android/i) == 'android'
  const windowsce = uA.match(/windows ce/i) == 'windows ce'
  const windowsmd = uA.match(/windows mobile/i) == 'windows mobile'
  const harmonyos = uA.match(/harmonyos.*mobile|openharmony.*mobile/i) != null

  if (!(ipad || iphone || midp || uc7 || uc || android || windowsce || windowsmd || harmonyos)) {
    // PC 端
    return false
  } else {
    // 移动端
    return true
  }
}

/**
 * 重定向到商户端
 * @param {*} url
 * @param {*} type
 */
export function redirectToUser (url, type) {
// 方法在这
  let href = window.location.href
  let urlHeader =
    href.indexOf('uat-m.ippmaster.com') !== -1
      ? 'https://uat-user.ippmaster.com/'
      : href.indexOf('http://m1.mdt.ost.com/') !== -1
        ? 'http://user1.mdt.ost.com/'
        : href.indexOf('http://m2.mdt.ost.com/') !== -1
          ? 'http://user2.mdt.ost.com/'
          : href.indexOf('http://m8.mdt.ost.com/') !== -1
            ? 'http://user8.mdt.ost.com/'
            : href.indexOf('m.ippmaster.com') !== -1
              ? 'https://user.ippmaster.com/'
              : `http://${window.location.hostname}:9001/`

  window.open(urlHeader + url, type)
}

/**
 * 获取地址栏的query，并转成对象形式
 * @returns
 */
export function getQuery () {
  let url = location.search // 获取url中"?"符后的字串
  let query = {}

  if (url.indexOf('?') !== -1) {
    let str = url.substr(1)
    let strs = str.split('&')

    for (let i = 0; i < strs.length; i++) {
      query[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1])
    }
  }

  return query
}

/**
 * 生成指定字符集的随机字符串
 * @param {*} length 长度
 * @returns
 */
export function generateRandomStr (length) {
  const chars = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z'
  ]
  const charsLength = chars.length - 1
  let res = ''

  for (let i = 0; i < length; i++) {
    let id = Math.ceil(Math.random() * charsLength)
    res += chars[id]
  }

  return res
}

// 判断是否显示营销弹窗
export function isShowActivityModal (name) {
  let activityModal = localStorage.getItem(name)
  let currentTime = moment()
  if (activityModal) {
    try {
      let activityModalObj = JSON.parse(activityModal)
      let time = moment(activityModalObj.time)
      let count = activityModalObj.count || 0
      if (currentTime.format('YYYY-MM-DD') === time.format('YYYY-MM-DD')) {
        if (count < 3) {
          let limitDay = time.add(1, 'hours')
          if (currentTime.isSameOrAfter(limitDay)) {
            localStorage.setItem(
              name,
              JSON.stringify({
                time: currentTime,
                count: count + 1
              })
            )
            return true
          }
        } else {
          return false
        }
      } else {
        localStorage.setItem(
          name,
          JSON.stringify({
            time: currentTime,
            count: 1
          })
        )
        return true
      }
    } catch (e) {
      return false
    }
  } else {
    localStorage.setItem(
      name,
      JSON.stringify({
        time: currentTime,
        count: 1
      })
    )
    return true
  }
  return false
}

// url跳转逻辑
export function linkSkip (url) {
  let pattern = /^https?:\/\/.+/
  let result = pattern.test(url)
  if (result) {
    window.location.href = url
  } else {
    // 当作小程序链接处理
    linkToProgram({
      path: url
    }).then(res => {
      if (res.code === 0) {
        window.location.href = res.data
      } else {
        this.$toast({ message: '系统繁忙，请稍后重试' })
      }
    }).catch(() => {
      this.$toast({ message: '系统繁忙，请稍后重试' })
    })
  }
}
// 唯一id
export function guid () {
  function S4 () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }
  return (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4())
}

// 生成唯一id作为设备id
export function getDeviceId () {
  let deviceId = localStorage.getItem('deviceId')
  if (deviceId) {
    // 本地有缓存，优先缓存
    return deviceId
  }
  deviceId = guid()
  localStorage.setItem('deviceId', deviceId)
  return deviceId
}

/**
 * 获取顶级域名，如果是本地则是本地的ip或者localhost
 * @returns
 */
export function getTopDomain () {
  let domain = '.ippmaster.com'
  const hostname = window.location.hostname

  if (hostname.indexOf('ippmaster.com') !== -1) {
    domain = '.ippmaster.com'
  } else if (hostname.indexOf('ost.com') !== -1) {
    domain = '.ost.com'
  } else {
    if (hostname.indexOf('localhost') !== -1) {
      domain = 'localhost'
    } else {
      domain = hostname
    }
  }

  return domain
}



// WEBPACK FOOTER //
// ./src/util/util.js